function closePopup() {
	const modal = document.getElementById('popup')
	if (modal) {
        modal.style.opacity = 0;
    }
	setTimeout(() => {
		if (modal) {
			modal.style.display = 'none'
		}
	}, 500)
}

function downloadImg(blockId) {
	const modal = document.getElementById('popup')
	// Получение URL-адреса изображения внутри блока
	const primaryImg = document.querySelector(`#${blockId} .f-png`)
	const primaryImgSrc = primaryImg.src

	document.getElementById('download-jpeg').href = `${primaryImgSrc.slice(
		0,
		-4
	)}.jpeg`
	document.getElementById('download-pdf').href = `${primaryImgSrc.slice(
		0,
		-4
	)}.pdf`
	document.getElementById('download-corel').href = `${primaryImgSrc.slice(
		0,
		-4
	)}.corel`

	modal.style.display = 'flex'
	setTimeout(() => {
		modal.style.opacity = 1
	}, 100)
}
